import { MobizGroup } from './mobiz-group.do';
import { OrganizationMembership } from './organization-membership.do';
import { SerializableObject } from './serializable-object';
import { UserEmail } from './user-email.do';

/** The user domain object. */
export class User extends SerializableObject {
  accessFailedCount: number;
  apiTokens: Object[]; // TODO: implement ApiToken.do
  createdUtc: Date;
  defaultEmail: string;
  emails: UserEmail[];
  fullName: string;
  groups: MobizGroup[];
  id: string;
  identificationNumber: string; // TODO : String or Number ?
  language: string;
  lastAccessFailedDateUtc: string;
  lockoutEnabled: boolean;
  lockoutEndDateUtc: Date;
  membership: OrganizationMembership[];
  modifiedUtc: Date;
  phoneNumber: string;
  phoneNumberConfirmed: boolean;
  twoFactorEnabled: boolean;
  username: string;

  protected coercePropertyType(propertyName: string, propertyValue: any): any {
    switch (propertyName) {
      case 'createdUtc':
      case 'modifiedUtc':
      case 'lockoutEndDateUtc':
        if (typeof propertyValue === 'string') {
          return new Date(propertyValue);
        } else if (propertyValue instanceof Date) {
          return propertyValue;
        }
        return undefined;

      case 'emails':
        const emailList: UserEmail[] = [];
        if (Array.isArray(propertyValue)) {
          propertyValue.forEach(itemData => {
            const email = new UserEmail(itemData);
            emailList.push(email);
          });
        }
        return emailList;

      case 'membership':
        const membershipList: OrganizationMembership[] = [];
        if (Array.isArray(propertyValue)) {
          propertyValue.forEach(itemData => {
            const membership = new OrganizationMembership(itemData);

            // Manually assign membership.user because it comes as `null` from backend
            // To avoid the circular reference, create a new instance of User and set the membership to null
            membership.user = new User();
            Object.assign(membership.user, this);
            delete membership.user.membership;

            membershipList.push(membership);
          });
        }
        return membershipList.sort((a: OrganizationMembership, b: OrganizationMembership) => {
          if (!a.organization || !b.organization) {
            return 0;
          }
          return a.organization.fullName.localeCompare(b.organization.fullName);
        });

      case 'groups':
        const groupList: MobizGroup[] = [];
        if (Array.isArray(propertyValue)) {
          propertyValue.forEach(itemData => {
            const group = new MobizGroup(itemData);
            groupList.push(group);
          });
        }
        return groupList;

      default:
        return super.coercePropertyType(propertyName, propertyValue);
    }
  }
}
